import React, { Component } from 'react';
import styles from '../components/Paper.module.css';



class Paper extends Component 
{
  
/*

  
  renderElement(element, index) 
  {
    // Assuming that an image element is an object with a 'src' property
    if (element.src) 
    {
      //console.log('image detetcted');
      return <img key={index} src={element.src} width={element.width} alt={element.alt || 'Image'} className={styles.image} />;
    }

    // Otherwise, treat it as text
    return <p key={index} className={styles.p}>{element.text}</p>;
  }

*/

  renderElement(element, index) 
  {
    //console.log('element:', element);
    
    //----- Element is an image object with a 'src' property -----
    
    if (typeof element === 'object') 
    {
      if (element.src)
      {
        //console.log('image detected');
        return <img key={index} src={element.src} width={element.width} alt={element.alt || 'Image'} className={styles.image} />;
      }

      if (element.image)
        {
          //console.log('image detected');
          return element.image;
        }
  
      //----- Shadow image header -----
      if (element.shadow)
      {
        return <p className={styles.image_shadow}> {element.shadow} </p>
      } 

      if (element.title)
      {
        return <p key={index} className={styles.headline} > {element.title} </p>
      }

      //----- Text header -----
      if (element.header)
      {
        return <p key={index}  {...element.style} >{element.header}</p>;      
      } 

      if (element.text)
      {
        //console.log('text:', element.text);
        return <p key={index} {...element.style}> {element.text}</p>;      
      }
    
      return '' 
    }
    //----- Element is not an object, then we assume just text
    //return <p key={index} >{element}</p>;  
  }
  



  render() 
  {
    const { textLines } = this.props;

    return (

      <div className={styles.text_block}>

          {textLines.map((line, index) => this.renderElement(line, index))}

      </div>
    );
  }
}

export default Paper;
